import { get } from './request'

export function getCategories() {
  return get(`/api/v1/open/article/categories`)
}

export function getArticles(query) {
  return get(`/api/v1/articles`, query)
}

export function getDetail(id) {
  return get(`/api/v1/article`, {
    id,
  })
}
